import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface AddToBlacklistResponse extends APIResponse
{
}

export class AddToBlacklistResponseDtoImpl extends APIResponseDtoImpl implements AddToBlacklistResponse
{
    
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/blacklist/addtoblacklist/addtoblacklistresponse.tsx